<template>
    <div class="row p-top-8 p-bottom-8">
        <div class="col-md-12">
            <label class="inputs-title">{{ attribute.attribute_name }}</label>
            <span style="cursor: pointer; position: relative;top: 1px;" @click="showPOPUI(attribute.extra_info)" v-if="attribute.extra_info !== ''">
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z"
                          fill="#CBCFD3"/>
                </svg>
            </span>
        </div>
        <div class="col-md-12">
            <!-- date -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                               :name="attribute.attribute_variable_name"
                               v-if="attribute.attribute_type_id == 8"
                               v-slot="{errors}">
              <div  :class="{ 'has-error':errors.length}">
                  <div class="time-attribute input-group">
                      <input
                          ref="date"
                          placeholder="Date"
                          :class="{ 'form-control': true, 'input-group-new-design-customer-attribute': true, 'pointerSelect': true }"
                          v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                          :readonly="true"
                      >
                      <span class="input-group-addon input-group-addon-new-design"><i class="fa fa-calendar"></i></span>
                  </div>
                <span class="text text-danger error-label">{{ errors[0] }}</span>
              </div>
          </validation-provider>

            <!-- time -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                               :name="attribute.attribute_variable_name"
                               v-else-if="attribute.attribute_type_id == 9"
                               v-slot="{errors}">
            <div  :class="{ 'has-error':errors.length}">
                <div class="time-attribute input-group">
                    <input
                        ref="time"
                        placeholder="Time"
                        :class="{ 'form-control': true, 'input-group-new-design-customer-attribute': true, 'pointerSelect': true }"
                        v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                        :readonly="true"
                    >
                    <span class="input-group-addon input-group-addon-new-design"><span class="glyphicon glyphicon-time"></span></span>
                </div>
              <span class="text text-danger error-label">{{ errors[0] }}</span>
            </div>
          </validation-provider>

            <!-- textarea -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                                 :name="attribute.attribute_variable_name"
                                 v-else-if="attribute.attribute_type_id == 10"
                                 v-slot="{errors}">
                <div :class="{ 'has-error':errors.length}">
                    <textarea
                        :name="attribute.attribute_variable_name"
                        v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                        class="long_text btextarea form-control p-all-15"
                        style="border-radius: 8px">
                    </textarea>

                    <span class="text text-danger error-label">{{ errors[0] }}</span>
                </div>

            </validation-provider>

            <!-- text input -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                                 :name="attribute.attribute_variable_name"
                                 v-else-if="attribute.attribute_type_id == 11 && ! attribute.is_new"
                                 v-slot="{errors}">
                <div :class="{ 'has-error':errors.length}">
                    <input
                        :name="attribute.attribute_variable_name"
                        type="text"
                        v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                        :class="{ 'input-new-design-customer-attribute': true, 'has-error':errors.length }"/>
                    <span class="text text-danger error-label">{{ errors[0] }}</span>
                </div>
            </validation-provider>

            <!-- plus minus input buttons  -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                                 :name="attribute.attribute_variable_name"
                                 v-else-if="attribute.attribute_type_id == 11 && attribute.is_new"
                                 v-slot="{errors}">
                <div :class="{ 'has-error':errors.length}">
                    <div class="plus-minus-attribute">
                        <div class="input-group">

                            <span class="input-group-btn input-group-prepend">
                                <button class="btn btn-outline bootstrap-touchspin-down minus-btn" @click="minusInput" type="button">-</button>
                            </span>

                            <input
                                    ref="counter"
                                    type="number"
                                    step="1"
                                    :name="attribute.attribute_variable_name"
                                    :min="attribute.min"
                                    :max="attribute.max"
                                    v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                                    :class="{ 'text-center form-control mobile-width': true, 'has-error':errors.length }"/>
                            <span class="input-group-addon bootstrap-touchspin-postfix input-group-append"
                                  v-if="attribute.title !== ''">
                                <span class="input-group-text p-10">{{ attribute.title }}</span>
                            </span>

                            <span class="input-group-btn input-group-append">
                                    <button class="btn btn-outline bootstrap-touchspin-up plus-btn" @click="plusInput" type="button">+</button>
                            </span>

                        </div>
                    </div>

                    <span class="text text-danger error-label">{{ errors[0] ?? validationErrors[attribute.attribute_variable_name] }}</span>
                </div>
            </validation-provider>

            <!-- toggle input (switch) -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                                 :name="attribute.attribute_variable_name"
                                 v-else-if="attribute.attribute_type_id == 7"
                                 v-slot="{errors}">
                <div :class="{ 'has-error':errors.length}">
                    <div class="toggle-attribute">
                        <label class="figma-switch">
                            <input
                                    type="checkbox"
                                    :id="`attribute_${attribute.attribute_id}`"
                                    :name="attribute.attribute_variable_name"
                                    true-value="Yes"
                                    false-value="No"
                                    v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"/>
                            <span for="toggle-attribute" class="slider round"> </span>
                        </label>
                    </div>
                    <span class="text text-danger error-label">{{ errors[0] }}</span>
                </div>
            </validation-provider>

            <!-- dropdown ( select one ) -->
            <validation-provider :rules="attribute.mandatory? 'required' : ''"
                                 :name="attribute.attribute_variable_name"
                                 v-else-if="attribute.attribute_type_id == 14"
                                 v-slot="{errors}">
                <div :class="{ 'has-error':errors.length}">
                    <select
                        :name="attribute.attribute_variable_name"
                        v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                        class="input-new-design-customer-attribute">
                        <option
                            v-for="value in attribute.attributeValues"
                            :value="value.attribute_value_id">
                            {{ value.attribute_value }}
                        </option>
                    </select>
                    <span class="text text-danger error-label">{{ errors[0] }}</span>
                </div>
            </validation-provider>

            <!-- radio button normal -->
            <div v-else-if="attribute.attribute_type_id == 12 && ! attribute.is_new">
                <div class="custom-field radio-btn-attribute">
                    <ul class="listSelected">
                        <li v-for="(value, index) of attribute.attributeValues" :key="index"
                            :class="{'selected': dataSubmit[`attribute_${attribute.attribute_id}`] == value.attribute_value_id, 'new-inputs': true}"
                            @click="addRadio(value.attribute_value_id, attribute.is_new)"
                            :data-target-active="value.attribute_value_id">
                            <span class="attribute-value attribute-value-font-weight">
                                {{ value.attribute_value }}
                            </span>
                            <span v-if="value.extra_info" class="extra-info" style="text-align: left;">{{ value.extra_info }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- radio button as button -->
            <div v-else-if="attribute.attribute_type_id == 12 && attribute.is_new">
                <div class="custom-field btngroup-attribute">
                    <ul class="listSelected">
                        <li v-for="(value, index) of attribute.attributeValues" :key="index"
                            :class="{'selected': dataSubmit[`attribute_${attribute.attribute_id}`] == value.attribute_value_id,'new-inputs': true}"
                            @click="addRadio(value.attribute_value_id, attribute.is_new)"
                            :data-target-new-active="value.attribute_value_id">
                            <span class="attribute-value attribute-value-font-weight">
                                {{ value.attribute_value }}
                            </span>
                            <span v-if="value.extra_info" class="extra-info" style="text-align: left;">{{ value.extra_info }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- dropdown ( select multi ) -->
            <div v-else-if="attribute.attribute_type_id == 15">
                <select multiple
                    :name="attribute.attribute_variable_name"
                    v-model="dataSubmit[`attribute_${attribute.attribute_id}`]"
                    :class="{ 'text-center': true, 'form-control': true, 'has-error': validationErrors[attribute.attribute_variable_name] }"
                    style="height: 100px !important">
                    <option
                        v-for="value in attribute.attributeValues"
                        v-bind:value="value.attribute_value_id">
                        {{ value.attribute_value }}
                    </option>
                </select>
                <span class="text text-danger error-label">{{ validationErrors[attribute.attribute_variable_name] }}</span>
            </div>

            <!-- checkbox as button -->
            <div v-else-if="attribute.attribute_type_id == 13 && ! attribute.is_new">
                <div class="custom-field btngroup-attribute">
                    <ul class="listSelected">
                        <li v-for="(value, index) in attribute.attributeValues" :key="index"
                            @click="addCheckBox(value.attribute_value_id, attribute.is_new)"
                            :data-target-check-active="value.attribute_value_id"
                            :class="{'new-inputs': true, 'selected':dataSubmit[`attribute_${attribute.attribute_id}`] && dataSubmit[`attribute_${attribute.attribute_id}`].includes(String(value.attribute_value_id))}">
                            <span class="attribute-value attribute-value-font-weight"> {{ value.attribute_value }} </span>
                            <span v-if="value.extra_info" class="extra-info" style="text-align: left;">{{ value.extra_info }}</span>
                        </li>
                    </ul>
                </div>
                <span class="text text-danger error-label">{{ validationErrors[attribute.attribute_variable_name] }}</span>
            </div>

            <!-- checkbox as normal -->
            <div v-else-if="attribute.attribute_type_id == 13 && attribute.is_new">
                <div class="custom-field btngroup-attribute">
                    <ul class="listSelected">
                        <li v-for="(value, index) in attribute.attributeValues" :key="index"
                            @click="addCheckBox(value.attribute_value_id, attribute.is_new)"
                            :data-target-check-new-active="value.attribute_value_id"
                            :class="{'new-inputs': true, 'selected':dataSubmit[`attribute_${attribute.attribute_id}`] && dataSubmit[`attribute_${attribute.attribute_id}`].includes(String(value.attribute_value_id))}">
                            <span class="attribute-value attribute-value-font-weight"> {{ value.attribute_value }} </span>
                            <span v-if="value.extra_info" class="extra-info" style="text-align: left;">{{ value.extra_info }}</span>
                        </li>
                    </ul>
                </div>
                <span class="text text-danger error-label">{{ validationErrors[attribute.attribute_variable_name] }}</span>
            </div>

            <!-- signature -->
            <div  v-else-if="attribute.attribute_type_id == 16 && ! attribute.is_new">
                <signature-attribute
                    :attribute="attribute"
                    :dataSubmit="dataSubmit"
                    :constrains="constrains"
                    :validationErrors="validationErrors"
                    :customerId="customerId">
                </signature-attribute>
            </div>
        </div>
    </div>
</template>

<script>


import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules';
import SignatureAttribute from "@/modules/Customer/components/SignatureAttribute.vue";
import Date from "@/modules/Fields/components/Date.vue";

email.message = 'This is invalid email'
required.message = 'This field is required'

extend('email', email);
extend('required', required);

export default {
    name: "CustomerAttributes",
    props: ["dataSubmit", "attribute", "validationErrors", "constrains", "customerId"],
    components: {
        SignatureAttribute,
        ValidationProvider,
        ValidationObserver,
        Date,
    },
    data() {
        return {
            dateInput: null,
            dateFormat: "DD, d MM yyyy",
            timeInput: null
        }
    },
    methods: {
        showPOPUI(message) {
            window.popupi_alert('Helper Text', message);
        },
        minusInput() {
            if (this.dataSubmit[`attribute_${this.attribute.attribute_id}`] > this.attribute.min) {
                this.dataSubmit[`attribute_${this.attribute.attribute_id}`] = +this.dataSubmit[`attribute_${this.attribute.attribute_id}`] - 1;
                // enta zbaalaa ya saa3eed :D
                this.$refs.counter.focus();
                this.$refs.counter.blur();
            }

        },
        plusInput() {
            if (this.dataSubmit[`attribute_${this.attribute.attribute_id}`] < this.attribute.max) {
                this.dataSubmit[`attribute_${this.attribute.attribute_id}`] = +this.dataSubmit[`attribute_${this.attribute.attribute_id}`] + 1;
                // enta zbaalaa ya saa3eed :D
                this.$refs.counter.focus();
                this.$refs.counter.blur();
            }

        },
        addRadio(value, isNew) {
            let vm = this;
            let dataTarget = !isNew ? "data-target-active" : "data-target-new-active";
            $("[" + dataTarget + "]").removeClass('selected');
            $("[" + dataTarget + "]").each(function () {
                if ($(this).attr(dataTarget) == value) {
                    $(this).addClass("selected");
                }
            });
            vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`] = value;
        },
        addCheckBox(value, isNew) {
            let vm = this;
            let dataTarget = !isNew ? "data-target-check-active" : "data-target-check-new-active";
            if (vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`].includes(value)) {
                $("[" + dataTarget + "=" + value + "]").removeClass('selected');
                vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`] = vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`].filter(e => e !== value);
            } else {
                $("[" + dataTarget + "=" + value + "]").addClass('selected');
                vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`].push(value);
            }
        },
        initiate() {
            let vm = this;
            this.dateInput = $(this.$refs['date']).datepicker({
                todayBtn: "linked",
                todayHighlight: true,
                keyboardNavigation: false,
                forceParse: false,
                calendarWeeks: true,
                autoclose: true,
                format: this.dateFormat,
            })
            $(this.dateInput).on('change', function () {
                vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`] = $(this).val();
            })
        },
        initiateTime(){
            let vm = this;
            this.timeInput = $(this.$refs['time']).clockpicker({
                donetext: 'Done',
                placement: 'top',
                align: 'left',
                autoclose: true,
            });
            $(this.timeInput).on("change", function () {
                vm.dataSubmit[`attribute_${vm.attribute.attribute_id}`] = $(this).val();
            });
        },
    },
    mounted() {
        this.initiate();
        this.initiateTime();
    },
}
</script>

<style scoped>

.input-group-addon-new-design{
  padding: 0px !important;
  width: 48px !important;
  height: 48px !important;
  background: #FFFFFF !important;
  border: 1px solid #DADEE2 !important;
  border-radius: 0px 8px 8px 0px !important;
}

.input-group-addon:last-child {
  color: #555;
}

.input-new-design-customer-attribute {
    padding: 12px 16px !important;
    width: 100% !important;
    height: 48px !important;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(218, 222, 226);
    background: #FFFFFF;
}

input:focus{
    outline: none !important;
    border:1px solid rgb(218, 222, 226) !important;
}

.inputs-title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #2E4051;
}

input[type="text"] {
    margin-bottom: -1px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.radio-btn-attribute ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
}

.btngroup-attribute ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
}

.radio-btn-attribute li {
    float: left;
}

.btngroup-attribute li {
    float: left;
}

.custom-field .attribute-label {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #2E4051;
}

.custom-field .new-inputs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 12px 16px;
    margin: 0 1% 1% 0;
    gap: 8px;
    background: #FFFFFF;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    cursor: pointer;
}

.custom-field .selected {
    border: 1px solid #03A9F4;
}

.minus-btn{
    border: 1px solid #E0E2E5 !important;
    border-radius: 8px 0px 0px 8px;
    color: #03A9F4 !important;
}

.plus-btn{
    border: 1px solid #E0E2E5 !important;
    border-radius: 0px 8px 8px 0px;
    color: #03A9F4 !important;
}

.attribute-value-font-weight {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 410;
    font-size: 16px;
    line-height: 16px;
    color: #2E4051;
}

.extra-info {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: #979FA8;
}

.time-attribute {
    width: 100% !important;
}

.input-group-new-design-customer-attribute {
    padding: 14px 16px !important;
    height: 48px !important;
    background: #FFFFFF !important;
    border: 1px solid #DADEE2 !important;
    border-radius: 8px 0px 0px 8px !important;
    margin-right: -1px !important;
    width: 100% !important;
}

.has-error {
    border-color: #a94442 !important;
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.date-icon {
    background-repeat: no-repeat;
    background-position: 15px 17px;
    padding-left: 45px !important;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6ZM6 12H4V10H6V12ZM10 12H8V10H10V12ZM14 12H12V10H14V12ZM6 16H4V14H6V16ZM10 16H8V14H10V16ZM14 16H12V14H14V16Z' fill='%232E4051'/%3E%3C/svg%3E%0A");
}

.pointerSelect:hover{
  cursor: pointer;
}

.bootstrap-touchspin-postfix{
    text-align: center !important;
}
.plus-minus-attribute {
    width: 30%;
}

@media (max-width: 768px) {
  .plus-minus-attribute {
    width: 100%;
  }
  .mobile-width {
    width: 125% !important;
  }
}

</style>